<template>
  <div>
    <div id="buttons" v-if="product == 'table'">
      <v-radio-group v-model="table">
        <v-radio
          :label="getText.individual + ' (+' + getTableIndividualPrice + '€)'"
          color="var(--accentColor)"
          value="individual"
        ></v-radio>
        <v-radio
          :label="getText.dining"
          color="var(--accentColor)"
          value="dining"
        ></v-radio>
        <v-radio
          :label="getText.office"
          color="var(--accentColor)"
          value="office"
        ></v-radio>
      </v-radio-group>
    </div>

    <div id="buttons" v-if="product == 'bench'">
      <v-radio-group v-model="bench">
        <v-radio
          :label="getText.individual + ' (+' + getBenchIndividualPrice + '€)'"
          color="var(--accentColor)"
          value="individual"
        ></v-radio>
        <v-radio
          :label="getText.bench2person"
          color="var(--accentColor)"
          value="twoPerson"
        ></v-radio>
        <v-radio
          :label="getText.bench3person"
          color="var(--accentColor)"
          value="threePerson"
        ></v-radio>
      </v-radio-group>
    </div>

    <div id="buttons" v-if="product == 'stool'">
      <v-radio-group v-model="stool">
        <v-radio
          :label="getText.individual + ' (+' + getStoolIndividualPrice + '€)'"
          color="var(--accentColor)"
          value="individual"
        ></v-radio>
        <v-radio
          :label="getText.stoolNormal"
          color="var(--accentColor)"
          value="normal"
        ></v-radio>
        <v-radio
          :label="getText.stoolHigh"
          color="var(--accentColor)"
          value="high"
        ></v-radio>
      </v-radio-group>
    </div>
  </div>
</template>

<script>

export default {
  name: 'sizeButtons',
  props: ['product'],
  data() {
    return{
      table: 'individual',
      bench: 'individual',
      stool: 'normal',
    }
   },
   components: {
   },
   computed: {
     getText(){
       return this.$store.getters.getText.configurator.dimensions
     },
     getTableIndividualPrice(){
       return this.$store.getters.getTableConfig.dimensions.costForIndividual
     },
     getBenchIndividualPrice(){
       return this.$store.getters.getBenchConfig.dimensions.costForIndividual
     },
     getStoolIndividualPrice(){
       return this.$store.getters.getStoolConfig.dimensions.costForIndividual
     },
   },
   methods: {
   },
   mounted (){
     switch (this.product){
       case 'table':
        this.table = this.$store.getters.getTableConfig.dimensions.chosen;
       break;
       case 'bench':
        this.bench = this.$store.getters.getBenchConfig.dimensions.chosen;
       break;
       case 'stool':
        this.stool = this.$store.getters.getStoolConfig.dimensions.chosen;
       break;
       default:
       break;
     }
   },
   watch: {
     table: function(){
        this.$store.dispatch("changeTableConfig", {change: 'dimensionType', value: this.table});
     },
     bench: function(){
        this.$store.dispatch("changeBenchConfig", {change: 'dimensionType', value: this.bench});
     },
     stool: function(){
        this.$store.dispatch("changeStoolConfig", {change: 'dimensionType', value: this.stool});
     },
   },
}
</script>

<style scoped>
  #configuratorDesktopSize {
    height: 100%;
    width: 100%;
  }
  #buttons{
    position: relative;
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  #sizeSlider{
    display: grid;
    grid-template-rows: 1fr 1fr 1fr;
  }

</style>
